export default {
  name: 'slider',
  label: '滑块',
  icon: 'el-icon-more-outline',
  dataType: 'Number',
  config: [{// 可修改的配置选项
  }]
};